/* eslint-disable quote-props */
const enMessages = {
  'title': 'CARDS PAYMENT & ID 2017 Official Catalogue',
  'shortTitle': 'CARDS Catalogue',
  // Navigation
  'generalProgramming': 'General Programming',
  'sponsors': 'Sponsors',
  'personalities': 'Personalities',
  'roundTables': 'Round Tables',
  'agenda': 'Agenda',
  'keynotes': 'Keynotes',
  'mediaPartners': 'Media Partners',
  'floorplan': 'Floorplan',
  'exhibitors': 'Exhibitors',
  'testimonials': 'Testimonials',
  'organization': 'Organization',
  'futurecomWebsite': 'CARDS website',
  'seeMore': 'See more',
  'back': 'Back',
  // Titles
  'coordinator': 'Coordinator',
  'invitedPanelists': 'Invited panelists',
  'participationAtTheCongress': 'Participation at the Congress:',
  'description': 'Description:',
  'scope': 'Scope:',
  'language': 'Language:',
  'themes': 'Themes:',
  'locale': 'Locale:',
  'mainExecutive': 'Main Executive: ',
  'marketingExecutive': 'Marketing Executive: ',
  'others': 'Others:',
  'roundTableDetailsRoom': '{icon} Room {room}',
  // Paragraphs
  'agendaText': 'See the full CARDS 2017\'s Agenda at:',
  'floorplanText': 'See the full CARDS 2017\'s map at:',
  'organizationText':
    `
      CARDS is part of the Global Exhibitions Division of Informa PLC.
    `,
  // Date and time
  'roundTableDateTime': '{icon} {date, date, short}, from {starting, time, short} to {ending, time, short}',
  'roundTableDetailsDateTime': '{icon} {date, date}, from {starting, time, short} to {ending, time, short}',
  'roundTableRoom': '{icon} ROOM {room}',
  'time': 'from {starting, time, short} to {ending, time, short}',
  // Other
  'booth': '+',
  'search': 'Search...',
  // Messages
  'noData': 'No data.',
};
/* eslint-enable */

export default enMessages;



/** WEBPACK FOOTER **
 ** ./src/intl/enMessages.js
 **/